import userRepository from "./UserRepository";
import auth from "./auth";
import kategoriSoalRepository from "./KategoriSoalRepository";
import kategoriTryoutRepository from "./KategoriTryoutRepository";
import paketTryoutRepository from "./PaketTryoutRepository";
import soalRepository from "./SoalRepository";
import mapelRepository from "./MapelRepository";
import paketMapelRepository from "./PaketMapelRepository";
import tryoutRepository from "./TryoutRepository";
import pengerjaanTryoutRepository from "./PengerjaanTryoutRepository";
import HasilTryOutRepository from "./HasilTryOutRepository";
import dashboardRepository from "./DashboardRepository";
import profileRepository from "./ProfileRepository";

//pembayaran
import Bayar from "./Bayar";
import OrderRepository from "./OrderRepository";

//Daerah
import ProvinsiRepository from "./ProvinsiRepository";
import KotaRepository from "./KotaRepository";
import KecamatanRepository from "./KecamatanRepository";

// Cart
import CartRepository from "./CartRepository";
import Invoice from "./Invoice";

// Products
import ProductsRepository from "./ProductsRepository";
import VoucherRepository from "./VoucherRepository";

// Events
import EventRepository from "./EventRepository";

// Bundles
import BundleRepository from "./BundleRepository";

// Perbandingan
import PerbandinganRepository from "./PerbandinganRepository";

// Rapor
import RaporRepository from "./RaporRepository";

const repositories = {
  userRepository,
  auth,
  kategoriSoalRepository,
  soalRepository,
  mapelRepository,
  paketMapelRepository,
  kategoriTryoutRepository,
  paketTryoutRepository,
  ProvinsiRepository,
  KotaRepository,
  KecamatanRepository,
  tryoutRepository,
  pengerjaanTryoutRepository,
  HasilTryOutRepository,
  CartRepository,
  Bayar,
  OrderRepository,
  Invoice,
  dashboardRepository,
  profileRepository,
  ProductsRepository,
  VoucherRepository,
  EventRepository,
  BundleRepository,
  PerbandinganRepository,
  RaporRepository,
};
export default {
  get: name => repositories[name],
};
